import React from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import Select from "../MSelect";
import {fontFamilies, pichshopFonts} from "../../services/lib/fonts";
import {isPichshopSelector} from "../../selectors";

function FontFamily(props) {
  const {current, isPichshop, handleChange} = props;
  return (
    <div className="font-family">
      <Select
        current={{value: current, label: current}}
        onChange={handleChange(`fontFamily`)}
        onPreviewHover={(fontFamily) => handleChange(`fontFamily`, fontFamily)()}
        options={Object.keys(fontFamilies)
          .map((font) => ({
            value: font,
            label: font
          }))
          .filter((font) => isPichshop || !pichshopFonts[font.value])}
        optionStyles={(option) => {
          return {
            fontFamily: option.value
          };
        }}
      />
    </div>
  );
}

FontFamily.propTypes = {
  current: PropTypes.string,
  handleChange: PropTypes.func,
  isPichshop: PropTypes.bool
};

export default connect((state) => ({
  isPichshop: isPichshopSelector(state)
}))(FontFamily);
